// extracted by mini-css-extract-plugin
module.exports = {"title":"samples-dialog_title_2L-NJ","content":"samples-dialog_content_3jbDY","samples":"samples-dialog_samples_1zKhI","secondary-button":"samples-dialog_secondary-button_2qebg"};